// @flow
import { schema } from 'normalizr'

const idAttribute = '_id'

export const tvProgramsSchema = new schema.Entity('tvPrograms', {}, { idAttribute })
export const tvProgramsListSchema = new schema.Array(tvProgramsSchema)

export default tvProgramsListSchema
